import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiAppLegacy } from '@heviton/heviton-api-app-legacy';
import { fromRawConsentDocs } from '@/shared/data-mappers';
import type { ConsentDoc } from '@/shared/data-types';

/** 약관 목록 query key. */
export const CONSENTS_QUERY_KEY = ['consents'] as const;

/**
 * 약관 목록 query 정의 SSOT — app-legacy(v3) `GET /consents` → `fromRawConsentDocs`(원문 인라인·순서정렬).
 * 고객센터 약관 목록·원문 뷰어 소스. staleTime 은 default(약관은 거의 불변 — 캐시 정책 정립 시 장기 후보,
 * agreement query 와 동일 방침).
 */
export const consentsQueryOptions = (api: HevitonApiAppLegacy) =>
  queryOptions<ConsentDoc[]>({
    queryKey: CONSENTS_QUERY_KEY,
    queryFn: async ({ signal }) => fromRawConsentDocs(await api.consent.list({ signal })),
  });
